export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'slate',
    button: {
      color: {

      },
      font: 'font-semibold',
      rounded: 'rounded-xl',
      padding: {
        xl: 'px-5 py-3'
      },
      default: {
        size: 'xl'
      },
      variant: {
        solid: 'shadow-sm text-white dark:text-gray-900 bg-{color}-500 hover:bg-{color}-600 disabled:bg-{color}-500 dark:bg-{color}-400 dark:hover:bg-{color}-500 dark:disabled:bg-{color}-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-{color}-500 dark:focus-visible:outline-{color}-400'
      }
    }
  }
})
